// extracted by css-extract-rspack-plugin
export default {"link":"_935a1e3f"};